import styled, { css } from "styled-components";
import { Wrapper } from "AppReact";

const CountWrapper = Wrapper(styled.div`
  ${({ theme }) => css`
      padding: 2px 6px;
      text-align: center;
      border-radius: 20px;
      background: ${theme?.colour?.primary ?? "#1DBD6B"};
      font-size: 12px;
      color: #FFFFFF,
      font-style: normal;
      font-weight: 400;
      line-height: normal;
  
      @media only screen and (min-width: 768px) {
        padding: 4px 8px;
      }
    `}
`);

export default CountWrapper;